import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateMoveTimesMutationVariables = Types.Exact<{
  moveId: Types.Scalars['bigint']['input'];
  pickupTime: Types.Scalars['timestamptz']['input'];
  deliveryTime: Types.Scalars['timestamptz']['input'];
  readyBy: Types.Scalars['timestamptz']['input'];
  deliverBy: Types.Scalars['timestamptz']['input'];
}>;


export type UpdateMoveTimesMutation = { __typename?: 'mutation_root', update_moves?: { __typename?: 'moves_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'moves', id: number, pickup_time?: string | null, delivery_time?: string | null, ready_by?: string | null, deliver_by?: string | null }> } | null };


export const UpdateMoveTimesDocument = gql`
    mutation updateMoveTimes($moveId: bigint!, $pickupTime: timestamptz!, $deliveryTime: timestamptz!, $readyBy: timestamptz!, $deliverBy: timestamptz!) {
  update_moves(
    where: {id: {_eq: $moveId}}
    _set: {pickup_time: $pickupTime, delivery_time: $deliveryTime, ready_by: $readyBy, deliver_by: $deliverBy}
  ) {
    affected_rows
    returning {
      id
      pickup_time
      delivery_time
      ready_by
      deliver_by
    }
  }
}
    `;
export type UpdateMoveTimesMutationFn = Apollo.MutationFunction<UpdateMoveTimesMutation, UpdateMoveTimesMutationVariables>;

/**
 * __useUpdateMoveTimesMutation__
 *
 * To run a mutation, you first call `useUpdateMoveTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoveTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoveTimesMutation, { data, loading, error }] = useUpdateMoveTimesMutation({
 *   variables: {
 *      moveId: // value for 'moveId'
 *      pickupTime: // value for 'pickupTime'
 *      deliveryTime: // value for 'deliveryTime'
 *      readyBy: // value for 'readyBy'
 *      deliverBy: // value for 'deliverBy'
 *   },
 * });
 */
export function useUpdateMoveTimesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoveTimesMutation, UpdateMoveTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoveTimesMutation, UpdateMoveTimesMutationVariables>(UpdateMoveTimesDocument, options);
      }
export type UpdateMoveTimesMutationHookResult = ReturnType<typeof useUpdateMoveTimesMutation>;
export type UpdateMoveTimesMutationResult = Apollo.MutationResult<UpdateMoveTimesMutation>;
export type UpdateMoveTimesMutationOptions = Apollo.BaseMutationOptions<UpdateMoveTimesMutation, UpdateMoveTimesMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/updateMoveTimes.mutation.gql}
 */
export async function updateMoveTimes(
  variables: UpdateMoveTimesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateMoveTimesMutation['update_moves']>
export async function updateMoveTimes(
  variables: UpdateMoveTimesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateMoveTimesMutation>
export async function updateMoveTimes(
  variables: UpdateMoveTimesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateMoveTimesMutation['update_moves'] | UpdateMoveTimesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateMoveTimesMutation>(
    UpdateMoveTimesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_moves
}